import React, { Component } from 'react';
import GridItem from './GridItem';
import Fade from 'react-reveal/Fade';
import TransitionGroup from 'react-transition-group/TransitionGroup';

var displayObjs
var gridItemArray = []

class Grid extends Component {
	constructor (props) {
		super(props)
		this.gridUpdate = this.gridUpdate.bind(this)
		this.handleGridClick = this.handleGridClick.bind(this)
		this.registerGridItem = this.registerGridItem.bind(this)
		this.updateSelectedGridItem = this.updateSelectedGridItem.bind(this)
    displayObjs = this.filterObjs(this.props.JSON,this.props.gridfilter)
    //this.initGrid()
    }

    registerGridItem(instance) {
      //console.log("Grid Item registered")
      gridItemArray.push(instance)
      instance.setState({selected:false})
    }

    updateSelectedGridItem(instance){
      //console.log("updated selected GridItem")
      gridItemArray.forEach((ins,index) => {
        if(ins!==instance){
          ins.setState({selected:false})
          } else {
            instance.setState({selected:true})
          }
      })
    }

    resetAllSelectedItems () {
      gridItemArray.forEach((ins,index) => {
        ins.setState({selected:false})
      })
    }

	filterObjs(fJSON, fallowed) {
		const filtered = Object.keys(fJSON)
		  .filter(key => fallowed.includes(key))
		  .reduce((obj, key) => {
		    return {
		      ...obj,
		      [key]: fJSON[key]
		    };
		  }, {});
 		console.log('objects were filtered')
		return filtered 
	}

	componentWillUpdate(nextProps,nextState){
		//console.log("about to render Grid"+nextProps.JSON+"|"+nextProps.gridfilter)
    displayObjs = this.filterObjs(nextProps.JSON,nextProps.gridfilter)
    //console.log("willupdate"+JSON.stringify(displayObjs))
	}

  componentDidMount(){
    var newArray=["header","filters","logogrid","cover"]
    this.props.updateView(newArray) 
    //console.log('initGrid has fired' + JSON.stringify(displayObjs))
  }

	handleGridClick(fproject,instance) {
    var newArray=["header","filters","logogrid"]
      this.props.updateView(newArray) 
		this.updateSelectedGridItem(instance)
		console.log('Handle GridClick has fired |'+fproject +'|'+instance)
      this.props.updateProject(fproject)
      this.setState({selected:true})
      this.gridUpdate()
	}

	gridUpdate() {
		//console.log('Grid project state is' + fproject+"|"+this.state.gridproject)
    
	}




  render() {
  	
    return (
 		<div className="gridBoundary fadeIn">
 		<TransitionGroup component={null}>
        {Object.keys(displayObjs).map((key,index) => (
       <Fade key={index}>
            		<GridItem clickCB={this.handleGridClick} regGI={this.registerGridItem} name={displayObjs[key].name} imgsrc={displayObjs[key].imgsrc} imgpath={displayObjs[key].imgpath} height={displayObjs[key].height} width={displayObjs[key].width} gikey={index} /> 
        </Fade>
        ))}
        	</TransitionGroup>
      </div>      
    );
  }
}

export default Grid;


// WEBPACK FOOTER //
// ./src/Grid.js